import { FC, useState } from 'react';

import { Box, Button, TextField, Typography, useTheme } from '@mui/material';

interface Props {
  /**
   * gift cards are applied as credits to the user's account.
   */
  redeemGiftCard(code: string): Promise<void>;
  redeemGiftCardError?: string | null;
  caption?: string;
}

const RedeemGiftCard: FC<Props> = ({
  redeemGiftCard,
  redeemGiftCardError,
  caption,
}) => {
  const theme = useTheme();
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function onClick() {
    setIsLoading(true);
    await redeemGiftCard(code);
    setCode('');
    setIsLoading(false);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '1rem',
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: theme.palette.secondary.main }}
      >
        {caption || 'Have a gift card?'}
      </Typography>
      <TextField
        sx={{ width: '100%' }}
        placeholder="Enter gift card"
        value={code}
        onChange={(event) => setCode(event.target.value)}
        error={!!redeemGiftCardError}
        helperText={redeemGiftCardError}
        slotProps={{
          input: {
            endAdornment: (
              <Button
                disabled={isLoading}
                variant="contained"
                color="primary"
                size="medium"
                onClick={onClick}
              >
                APPLY
              </Button>
            ),
          },
        }}
      />
    </Box>
  );
};

export default RedeemGiftCard;
